import React from 'react'
import { useScrollOver } from '@gluedigital/scrollastic'
import MarkdownMessage from '@gluedigital/markdown-message'
import './HeroBanner.sass'

const HeroBanner = () => {
  const progress = useScrollOver('#hero-banner')

  return (
    <section className="section" id="hero-banner">
      <div id="stroke-hero-2" className="stroke"
        style={{ transform: `translateY(${progress * -120}vh` }} />
      <div className="container">
        <div className="split">
          <div className="item left">
            <div className="wrapper">
              <h1>
                <MarkdownMessage id="home.hero-banner.title" />
                <div className="glumail-logo" />
              </h1>
              <div className="google-logo" />
            </div>
          </div>
          <div className="item right">
            <div id="hand" />
          </div>
        </div>
      </div>
      <div id="stroke-hero-1" className="stroke"
        style={{ transform: `translateY(${progress * 70}vh` }} />
    </section>
  )
}

export default HeroBanner
